<div [innerHtml]="html | styleImgPipe | trustHtmlPipe" (click)="closeModal()" ></div>

<!-- <ion-button (click)="closeModal()" fill="clear" shape="round" color="dark">
  <ion-icon slot="icon-only" name="close"></ion-icon>
</ion-button> -->